import { render, staticRenderFns } from "./MyReplyForm.vue?vue&type=template&id=fadf4940&"
import script from "./MyReplyForm.vue?vue&type=script&lang=js&"
export * from "./MyReplyForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports